import {
  call,
  put,
  select,
} from 'redux-saga/effects';

import {
  actions as modalActions,
} from '@gc-npm/reducers.modals-reducer';
const {  CloudTraceService } = require('@gc-npm/gcp-services.open-telemetry');
import {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@gc-npm/components.modal';
import SecureUserStorage from '@gc-npm/utils.secure.user-secure-storage';
import FrontSonda from '@gc-npm/utils.monitoring.front-sonda';

import { actions as uiActions } from '@/reducers/ui';
import { actions as modulesActions } from '@/reducers/modules';
import { purchase as purchasePromise } from '@/sagas/adabyron/purchase';
import { navigate2PurchaseProcess, navigate2Refresh } from '@/sagas/ui';
import { getMyR2R } from '@/sagas/client';
import PreventionsModal from '@/components/Modals/PreventionsModal';
import PurchaseInProgressModal from '@/components/Modals/PurchaseInProgressModal';
import { API_STATUS, SCREEN_TYPES } from '@/utils/constants';
import { getTaponInfo, getUrlParams } from '@/utils/index';

const filePath = '/sagas/cart.js';

const mainStore = (state) => state.main;
const clientStore = (state) => state.client;
const cartStore = (state) => state.cart;
const uiStore = (state) => state.UI;

function* showPreventions(preventions, purchaseProcess) {
  if (preventions && Array.isArray(preventions) && preventions.length > 0) {
    yield put(uiActions.setBouncingLogo(false));
    const ui = yield select(uiStore);
    const { screenType } = ui;
    yield put(modalActions.addModal({
      id: 'PreventionsModal',
      Element2Show: PreventionsModal,
      modalProps: {
        closeByClickingOutside: false,
        contentPosition:
        screenType === SCREEN_TYPES.MOBILE
          ? CONTENT_POSITION.CENTER_BOTTOM
          : CONTENT_POSITION.CENTER_CENTER,
        inSceneEffect:
        screenType === SCREEN_TYPES.MOBILE
          ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
          : IN_SCENE_EFFECT.FADE_IN,
        outSceneEffect:
        screenType === SCREEN_TYPES.MOBILE
          ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
          : OUT_SCENE_EFFECT.FADE_OUT,
        opacityLayoutColor: 'blur',
        scrollAllowed: false,
      },
      elementProps: {
        screenType,
        preventions,
        purchaseProcess,
      },
    }));
    // Obtener cuotas R2R
    const preventionWithR2R = preventions.find((prevention) => prevention.r2r);
    const { r2r } = preventionWithR2R || {};
    if (r2r) {
      yield call(getMyR2R, {
        productOfferingConvergente: r2r.bundleId,
      });
    }
  } else {

    // Proceso de compra
    yield call(navigate2PurchaseProcess, { purchaseProcess });
  }
}

function* showPurchaseInProgressModal(data) {
  const ui = yield select(uiStore);
  const { screenType } = ui;
  yield put(modalActions.addModal({
    id: 'PurchaseInProgressModal',
    Element2Show: PurchaseInProgressModal,
    modalProps: {
      closeByClickingOutside: false,
      contentPosition:
      screenType === SCREEN_TYPES.MOBILE
        ? CONTENT_POSITION.CENTER_BOTTOM
        : CONTENT_POSITION.CENTER_CENTER,
      inSceneEffect:
      screenType === SCREEN_TYPES.MOBILE
        ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
        : IN_SCENE_EFFECT.FADE_IN,
      outSceneEffect:
      screenType === SCREEN_TYPES.MOBILE
        ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
        : OUT_SCENE_EFFECT.FADE_OUT,
      opacityLayoutColor: 'blur',
      scrollAllowed: false,
    },
    elementProps: {
      screenType,
      ...data,
    },
  }))
}

async function getPurchaseInProgressInfo(userId) {
  const mySecureUserStorage = new SecureUserStorage();
  const secureInfoClient = await mySecureUserStorage.getUserStore({ id: userId });
  const { purchaseInProgress } = secureInfoClient || {};
  return purchaseInProgress;
}

export function* purchase({ cartIds, price: priceParam }) {
  const cloudTraceServicePurchase = new CloudTraceService('front/purchaseConfig');
  cloudTraceServicePurchase.startSpan()
  yield put(modulesActions.setStatusSelection(API_STATUS.LOADING));
  
  let selectedIds = null
  let price = null;
  if (!cartIds) {
    const cart = yield select(cartStore);
    
    const { modulos, price: priceCart } = cart || {};
    price = priceCart;
    const { items } = modulos || {};
    selectedIds = items;
  } else {
    selectedIds = cartIds;
    price = priceParam;
  }
  const ui = yield select(uiStore);
  const main = yield select(mainStore);
  const client = yield select(clientStore);
  const { context, zone } = main || {};
  const frontSonda = new FrontSonda({
    processName: 'purchase',
    context,
    filePath,
  });
  const userId = context?.userIdPartyHash;
  const processId = ui?.processId
  const purchaseInProgress = yield call(getPurchaseInProgressInfo, userId);
  if (purchaseInProgress) {
    yield put(uiActions.setBouncingLogo(false));
    const { ts, counter } = purchaseInProgress;
    const ahora = Date.now();
    const hanPasadoTresMinutos = (ahora - ts) >= 3 * 60 * 1000;

    if (hanPasadoTresMinutos) {
      frontSonda.infoMessage({
        error: 'navigate2Refresh',
        info: `Han pasado 3 minutos desde que tenemos pedido en vuelo - refresco nº${counter + 1}`,
      });
      yield call(navigate2Refresh);
      return;
    }
  }
  const {
    bundleId,
    modulos: clientModules,
    conexion,
    tv,
    oldTv,
    mobile,
    netflix,
    campaignsRedeemed,
    productZoneId,
    productCategory,
    price: clientPrice,
    mirrorFusionModules,
    productType,
    r2r,
    promotions,
    bundleModules,
    pocas,
    speedId,
  } = client;
  const sessionZone = productZoneId || zone;
  let clientInfo = null;

  if (bundleId || context?.userType === 'Telco') {
    clientInfo = {
      bundleId,
      conexion,
      modulos: clientModules,
      tv,
      oldTv,
      mobile,
      netflix,
      campaignsRedeemed,
      productCategory,
      price: clientPrice,
      mirrorFusionModules,
      productType,
      r2r,
      promotions,
      bundleModules,
      pocas,
      speedId,
    }
  }

  const urlParams = getUrlParams();
  let data = null;
  let purchaseError = null;
  try {
    data = yield call(
      purchasePromise,
      {
        context,
        selectedIds,
        clientInfo,
        sessionZone,
        price,
        urlParams,
        purchaseInProgress,
        processId,
      },
    );
  } catch (error) {
    purchaseError = error;
    if (
      error
      && (error.statusCode === 490 || error.statusCode === 491 || error.statusCode === 493 || error.statusCode === 494 || error.statusCode === 495)
      && error.data
    ) {
      // Error controlado
      console.error(error);
      data = JSON.parse(error.data);
      frontSonda.warningMessage({
        info: `Error en Purchase: ${error.error}`,
      });
    } else {
      console.error(error);
      frontSonda.errorMessage({
        error: `Fallo en Purchase: ${JSON.stringify(error)}`,
        info: 'Fallo en servicio Purchase',
      });
    }
  }

  if (data) {
    
    yield put(modulesActions.setStatusSelection(API_STATUS.OK));
    const {
      inFlight,
      empty,
      purchaseProcess,
      preventions,
      error,
      tapon,
    } = data;

    if (error) {
      frontSonda.errorMessage({
        error: `Fallo en Purchase: ${JSON.stringify(error)}`,
        info: 'Fallo en servicio Purchase',
      });
    }
    if (empty) {
      yield put(uiActions.setBouncingLogo(false));
      yield put(uiActions.setNotification(empty));
    } else if (inFlight) {
      yield put(uiActions.setBouncingLogo(false));
      yield call(showPurchaseInProgressModal, { ...inFlight });
    } else if (tapon) {
      yield put(uiActions.setBouncingLogo(false));
      yield put(uiActions.setTapon({
        ...getTaponInfo(client, '500'),
        componentContent: 'Bloqueado por pedido tramitandose en BackOffice',
        ...tapon,
      }));
    } else {
      yield call(showPreventions, preventions, purchaseProcess);
    }
    cloudTraceServicePurchase.endSpan()
  } else {
    cloudTraceServicePurchase.endSpanWithError('Fallo en el servicio purchase');
    yield put(uiActions.setBouncingLogo(false));
    yield put(modulesActions.setStatusSelection(API_STATUS.KO));
    yield put(uiActions.setTapon({
      ...getTaponInfo(client, data?.statusCode || purchaseError?.statusCode || '500'),
      componentContent: 'Fallo en el servicio purchase',
    }));
  }
}
